import { Marker } from 'react-mapbox-gl';
import React from 'react';
import PropTypes from 'prop-types';
import { CoordinatesExact } from '../../models/Coordinates';
import { Icon } from '../../../common/components/icons';
import useStyles from './Airport.styles';

const Airport = ({ coordinate, visible }) => {
  const classes = useStyles();

  if (!visible) return null;

  return (
    <Marker coordinates={[coordinate.longitude, coordinate.latitude]} anchor="center">
      <Icon icon="flight" className={classes.icon} />
    </Marker>
  );
};

Airport.propTypes = {
  coordinate: CoordinatesExact.isRequired,
  visible: PropTypes.bool,
};

Airport.defaultProps = {
  visible: true,
};

export default React.memo(Airport);
